/* =============================================================
   SENCHADO GIFT WRAP — G3a ラッピング動線（層1: 動線 + 層2: 整合チェッカー）
   仕様: docs/spec-gift-redesign.md §G3 / 決裁 2026-07-13。

   三点セット（ロジレス検証済みの紐付けデータ）:
     対象明細:  { 'ギフト包装': <資材名>, '_wrap_id': <token> }
     資材明細:  { '包装対象': <対象商品名>, '_wrap_id': <token> }
     照合は _wrap_id のみで行う（商品名照合は禁止）。
   包装付き対象明細は数量1固定（同じ商品をもう1つ包む＝もう1行）。

   ⚠️ 層3（サーバー検証・別Sprint G3b）が最終防波堤である前提。本JSは主にUX担保であり、
      悪意ある改変・JS無効・レース時の不整合はサーバー側で最終的に弾く設計とする。
      （例: /cart/change.js での property 除去は空文字クリアに依存しており、
        Shopify仕様変更や競合更新に対する完全性は保証しない。層3で担保する。）

   本ファイルは純関数を CommonJS export し（tests/gift-wrap.spec.js が直接 require）、
   ブラウザ実行時のみ DOM 配線を行う（document/window ガード）。
   ============================================================= */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api; // Node（テスト）
  }
  if (typeof window !== 'undefined') {
    window.SCGiftWrap = api;
    if (typeof document !== 'undefined') api._initBrowser();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // ---- 紐付けキー定数（SSOT） ----
  var KEY_WRAP_ID = '_wrap_id';
  var PROP_TARGET = 'ギフト包装'; // 対象明細の可読プロパティ（値=資材名）
  var PROP_MATERIAL = '包装対象'; // 資材明細の可読プロパティ（値=対象商品名）

  // ========================= 純関数（テスト対象） =========================

  // 追加後の .btn-cart 復帰。PDP では「いま選ばれている種類」の在庫で状態を決め直す
  // （追加中に売切れの種類へ替えられた場合に「カートに追加する」へ戻さないため）。
  function restoreBtn(btn, original) {
    delete btn.dataset.busy;
    btn.disabled = false;
    btn.textContent = original;
    var hero = typeof window !== 'undefined' && window.SenchadoHero;
    if (hero && typeof hero.syncPurchaseButton === 'function') hero.syncPurchaseButton();
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // 目視照合できる短さの文字（紛らわしい I / O を除外）。
  var TOKEN_CHARS = '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ';
  var TOKEN_LEN = 6;

  // 一意トークン（両明細に同一値を付ける）。
  //
  // 2026-08-03: 長いランダム文字列（gw_<時刻36>_<乱数>）から **短い可読トークン**（例: gw_K3N9X2）へ変更。
  //   理由: 1注文で複数セットをそれぞれ別の色で包む場合、出荷指示書上で
  //   「どのセットをどの風呂敷で包むか」を倉庫が突き合わせられる必要がある。
  //   可読プロパティ（'ギフト包装' / '包装対象'）は値が商品名なので、同じセットを2つ買うと
  //   同じ文言が2行並んで判別できない。
  //
  //   可読プロパティ側に記号を足す案は採らない —— `_` で始まらないプロパティは
  //   顧客のカート・注文詳細に表示される（sections/main-cart-items.liquid の
  //   `property_first_char != '_'` 判定ほか）ため、内部の紐付け記号が顧客に見えてしまう。
  //   `_wrap_id` は `_` 始まりなので顧客には表示されず、注文データには載る。
  //   → **顧客体験を変えずに、倉庫向けの識別子だけを読みやすくできる。**
  //
  //   照合ロジックは従来どおり _wrap_id の完全一致のみ（商品名照合は禁止）。
  //   一意性はカート内で足りる。34^6 ≒ 15億通りで、1カート内の衝突は無視できる。
  function newToken() {
    var bytes = null;
    try {
      if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
        bytes = new Uint8Array(TOKEN_LEN);
        crypto.getRandomValues(bytes);
      }
    } catch (_) {
      /* fallthrough */
    }
    var out = '';
    for (var i = 0; i < TOKEN_LEN; i++) {
      var n = bytes ? bytes[i] : Math.floor(Math.random() * 256);
      out += TOKEN_CHARS.charAt(n % TOKEN_CHARS.length);
    }
    return 'gw_' + out;
  }

  // 対象明細＋資材明細の2行を組み立てる（/cart/add.js の items 配列）。
  function buildPairItems(o) {
    var targetProps = {};
    targetProps[PROP_TARGET] = String(o.materialName);
    targetProps[KEY_WRAP_ID] = o.token;
    var materialProps = {};
    materialProps[PROP_MATERIAL] = String(o.targetTitle);
    materialProps[KEY_WRAP_ID] = o.token;
    return [
      { id: Number(o.targetVariantId), quantity: 1, properties: targetProps },
      { id: Number(o.materialVariantId), quantity: 1, properties: materialProps },
    ];
  }

  // 紙袋（お渡し用）を「数量1の通常明細」として組み立てる（2026-07-22）。
  //   風呂敷の2行ペア（_wrap_id 紐付け）とは独立した、プロパティ無し・_wrap_id 無しの単純明細。
  //   → 整合チェッカー(analyzeCart)は _wrap_id 無し明細を素通しするため、紙袋は照合対象外（bag非干渉）。
  //   顧客は自由に削除・数量変更できる（同梱物であって包装ペアではない）。
  function buildBagItem(bagVariantId) {
    return { id: Number(bagVariantId), quantity: 1 };
  }

  // 棚（資材）の在庫ガード: available===false を落とす（登録=出る/売切=落ちる）。
  function filterShelf(items) {
    return (items || []).filter(function (i) {
      return i && i.available === true;
    });
  }

  // 風呂敷サイズ判定（2026-07-21 サイズ自動割当）:
  //   variant title の先頭1文字が「小」→ 'small'・「大」→ 'large'・それ以外/空 → null。
  //   管理側は「小（48cm）」「大（70cm）」で作成する前提。判定不可（箱・Default Title 等）は null。
  //   ⚠️ この規則は senchado-gift-wrap-{option,cart,data}.liquid のサーバ側判定と一致させる（三者同時更新）。
  function detectSize(variantTitle) {
    var s = variantTitle == null ? '' : String(variantTitle);
    var first = s.charAt(0);
    if (first === '小') return 'small';
    if (first === '大') return 'large';
    return null;
  }

  // 「資材が風呂敷か」の判定マーカー（SSOT・2026-07-21）。サーバ側3スニペットの
  //   `p.title contains '風呂敷'` と一字一句同一の文字列で照合する（三者同時更新）。
  //   この語を変えるなら senchado-gift-wrap-{option,cart,data}.liquid も同時に変える。
  var FUROSHIKI_TITLE_MARK = '風呂敷';
  function isFuroshikiTitle(productTitle) {
    return String(productTitle == null ? '' : productTitle).indexOf(FUROSHIKI_TITLE_MARK) !== -1;
  }

  // 「資材が紙袋か」の判定マーカー（SSOT・2026-07-22 紙袋オプション）。サーバ側3スニペットの
  //   `p.title contains '紙袋'` と一字一句同一の文字列で照合する（三者同時更新）。
  var BAG_TITLE_MARK = '紙袋';
  function isBagTitle(productTitle) {
    return String(productTitle == null ? '' : productTitle).indexOf(BAG_TITLE_MARK) !== -1;
  }

  // 資材グループ判定の SSOT（2026-07-22）。判定順は 風呂敷→furoshiki／紙袋→bag／それ以外→box。
  //   サーバ側3スニペット（option/cart/data）の分岐順（風呂敷 contains を先に評価し、次に紙袋、
  //   どちらでもなければ box）と順序まで一致させる（三者同時更新）。
  //   ⚠️ 風呂敷が紙袋より先＝両方の語を含む想定外の題名でも furoshiki を優先する。
  function classifyGroup(productTitle) {
    if (isFuroshikiTitle(productTitle)) return 'furoshiki';
    if (isBagTitle(productTitle)) return 'bag';
    return 'box';
  }

  // 資材明細のサイズを返す（風呂敷限定ゲート・2026-07-21）。
  //   サーバ側と非対称にならないよう、サイズ判定は「product_title が『風呂敷』を含む」資材にのみ適用する。
  //   風呂敷でない資材（箱・その他）は variant title が「大」等でも size=null＝サイズ照合対象外
  //   （箱はサイズ非依存でペア成立）。cart.js 明細（{product_title, variant_title}）を受ける。
  //   ⚠️ 無条件 detectSize は不可: 箱が「ギフトボックス大」等の名でも size が付き、
  //     analyzeCart のサイズ不一致分岐が誤発火→正当ペアを破壊的 teardown する（敵対レビュー指摘1）。
  function materialSize(item) {
    var it = item || {};
    if (!isFuroshikiTitle(it.product_title)) return null;
    return detectSize(it.variant_title);
  }

  // 明細リストから小/大が確定している最初の値を返す（未確定=null は照合対象外）。
  function _firstKnownSize(list, prop) {
    for (var i = 0; i < (list || []).length; i++) {
      var v = list[i] && list[i][prop];
      if (v === 'small' || v === 'large') return v;
    }
    return null;
  }

  // カートモジュールを出すか: 未包装のwrappable対象があり、かつ在庫あり資材がある時だけ。
  function shouldShowCartModule(targetLines, availableShelf) {
    return (
      Array.isArray(targetLines) &&
      targetLines.length > 0 &&
      Array.isArray(availableShelf) &&
      availableShelf.length > 0
    );
  }

  function _isFilled(v) {
    return v != null && String(v).trim() !== '';
  }

  // カート明細を走査して不整合を抽出する（照合は _wrap_id のみ）。
  // items: [{ line, id, quantity, properties, product_title, title }]
  function analyzeCart(items) {
    var byToken = {};
    (items || []).forEach(function (it) {
      var props = it.properties || {};
      var token = props[KEY_WRAP_ID];
      if (!_isFilled(token)) return;
      if (!byToken[token]) byToken[token] = { targets: [], materials: [] };
      if (_isFilled(props[PROP_TARGET])) byToken[token].targets.push(it);
      else if (_isFilled(props[PROP_MATERIAL])) byToken[token].materials.push(it);
    });

    var targetOrphans = []; // 資材だけ削除 → 対象側のプロパティを自動除去
    var materialOrphans = []; // 対象削除 → 資材の扱いをユーザーに確認
    var sizeMismatches = []; // 対象の gift_wrap_size と 風呂敷の size が食い違うペア（下記参照）
    var pairs = [];
    Object.keys(byToken).forEach(function (token) {
      var g = byToken[token];
      if (g.targets.length && g.materials.length) {
        // サイズ整合（2026-07-21 自動割当）: 対象明細の gift_wrap_size(wrapSize) と
        //   風呂敷資材明細の size を照合。双方が既知(small/large)で食い違う時のみ「不整合」。
        //   size 不明（箱・判定不可・データ欠落）は照合対象外＝従来どおりペア成立（箱はサイズ非依存）。
        //   自動割当のため通常経路では発生しない。直POST等の抜け道で混入した不一致ペアを、
        //   既存の「未ペア」扱いに倒す: 対象→targetOrphan（wrapプロパティ自動除去）／
        //   資材→materialOrphan（確認UI＋レジ停止）。多対1拡張時は per-target 照合へ再設計。
        var tSize = _firstKnownSize(g.targets, 'wrapSize');
        var mSize = _firstKnownSize(g.materials, 'size');
        if (tSize && mSize && tSize !== mSize) {
          g.targets.forEach(function (t) {
            targetOrphans.push(t);
          });
          g.materials.forEach(function (m) {
            materialOrphans.push(m);
          });
          sizeMismatches.push({
            token: token,
            targets: g.targets,
            materials: g.materials,
            targetSize: tSize,
            materialSize: mSize,
          });
        } else {
          pairs.push({ token: token, targets: g.targets, materials: g.materials });
        }
      } else if (g.targets.length) {
        g.targets.forEach(function (t) {
          targetOrphans.push(t);
        });
      } else if (g.materials.length) {
        g.materials.forEach(function (m) {
          materialOrphans.push(m);
        });
      }
    });

    // 包装明細（対象・資材の両方）の数量>1 → 1に戻す。
    // 1ペア = 対象(qty1)+資材(qty1)・同一_wrap_id。資材側の数量無防備を塞ぐ
    // （breach: 資材のネイティブ数量ステッパーで qty>1 → 対象1に資材N個で曖昧出荷）。
    var qtyViolations = [];
    (items || []).forEach(function (it) {
      var props = it.properties || {};
      var isWrapLine =
        _isFilled(props[KEY_WRAP_ID]) && (_isFilled(props[PROP_TARGET]) || _isFilled(props[PROP_MATERIAL]));
      if (isWrapLine && Number(it.quantity) > 1) {
        qtyViolations.push(it);
      }
    });

    return {
      targetOrphans: targetOrphans,
      materialOrphans: materialOrphans,
      qtyViolations: qtyViolations,
      sizeMismatches: sizeMismatches,
      pairs: pairs,
    };
  }

  // analyzeCart の結果から自動修復の /cart/change.js オペ列を組み立てる（純関数・テスト対象）。
  // ⚠️ 行位置 line ではなく **race-safe な line item key**（it.key）で送る。
  //   position index は他タブ/割り込み操作・property変更由来の line-merge で別行を叩くため使わない。
  //   key が無い明細（テスト等で未指定）は line フォールバックするが、本番 runChecker は必ず key を積む。
  function _opTarget(it) {
    return _isFilled(it && it.key) ? { id: it.key } : { line: it && it.line };
  }
  function buildAutoOps(analysis) {
    var a = analysis || {};
    var ops = [];
    (a.qtyViolations || []).forEach(function (it) {
      var op = _opTarget(it);
      op.quantity = 1; // 対象・資材ともに数量1へ矯正
      ops.push(op);
    });
    (a.targetOrphans || []).forEach(function (t) {
      var op = _opTarget(t);
      op.properties = stripWrapProps(t.properties);
      ops.push(op);
    });
    return ops;
  }

  // runChecker の処理計画を analysis から決める純関数（テスト対象・監査 M27）。
  //   autoOps（数量矯正・対象孤児のプロパティ除去）と materialOrphan のレジ停止判定は **独立** に決める。
  //   ⚠️ autoOps があっても blockCheckout を握り潰さない。旧実装は autoOps 検出で早期 return し、
  //     同一パスで共存する materialOrphan（対象削除・資材残存）のレジ停止・確認UIを、ドロワー経路
  //     （refreshCart が renderContents で DOM 差替のみ＝再走査しない）で取りこぼしていた。
  //     materialOrphan 明細は autoOps の対象外なので、修復後も未解決のまま残り続ける。
  //   syncNote: この経路が自分で note を作り直す必要があるか（2026-08-21）。
  //     autoOps がある場合は修復チェーンの後に syncThenRefresh が走るので false。
  //     autoOps が無い場合、旧実装は note に一切触れずに終わっていた。カートUIで対象と資材の
  //     **両方**が消えると孤児も autoOps も残らないため、中身の無い【ギフト包装の指示】が
  //     備考欄に残り、倉庫が注文に無い商品の包装指示を受け取る（2026-08-14 事故と同型）。
  function planChecker(analysis) {
    var a = analysis || {};
    var materialOrphans = a.materialOrphans || [];
    var autoOps = buildAutoOps(a);
    return {
      autoOps: autoOps,
      blockCheckout: materialOrphans.length > 0,
      materialOrphans: materialOrphans,
      syncNote: autoOps.length === 0,
    };
  }

  // 明細のプロパティから包装用キーを除去した properties を返す（/cart/change.js 用・空文字でクリア）。
  function stripWrapProps(props) {
    var out = {};
    Object.keys(props || {}).forEach(function (k) {
      if (k === KEY_WRAP_ID || k === PROP_TARGET || k === PROP_MATERIAL) return;
      out[k] = props[k];
    });
    out[PROP_TARGET] = '';
    out[PROP_MATERIAL] = '';
    out[KEY_WRAP_ID] = '';
    return out;
  }

  // ---- 出荷指示書 特記事項へ渡す作業指示（2026-08-18 谷本決裁） ----
  //
  // なぜ note に書くのか:
  //   明細プロパティ（'ギフト包装' / '包装対象'）は**倉庫の紙に出ない**。
  //   エクシークの回答（2026-08-17・Asana 1216755305207481）:
  //     「・特記事項に記載があれば特記事項
  //       ・なければ明細行を見て判断（弊社の登録状況では、特に明細行にはなにも
  //         表示されていない状態です）
  //       出来ればすべて特記事項に記載していただくのが理想です」
  //   ＝梱包者が読むのは「出荷指示書 特記事項」。ロジレスの受注伝票マクロは
  //   購入者備考欄（note）を特記事項へ転記できる（公式の運用アイデア）ため、
  //   note に作業指示を書いて、マクロ1本で現場の紙まで届かせる。
  //   この経路なら風呂敷の色やサイズが増えてもマクロは1本のまま。
  //
  //   ⚠️ 実際に紙へ出ることはテスト受注で確認するまで未検証（Asana ④）。
  //
  // 文面は倉庫が注文 #330617 で手書きした出荷指示書をそのまま雛形にしている
  // （現場が使っている言葉に合わせるため。こちらで言い換えない）。
  //
  // 🔴 note は顧客が書く欄と共用。マーカーで囲んだ区間だけを機械が管理し、
  //    顧客が書いた文は1文字も触らない。作業指示は**先頭**に置く
  //    （谷本決裁 2026-08-18 案B＝倉庫は特記事項の頭から読むため）。
  var NOTE_MARK_BEGIN = '【ギフト包装の指示】';
  var NOTE_MARK_END = '【ギフト包装の指示 ここまで】';

  // 明細1行を「商品コード　商品名 - バリアント名」に整形する。
  //   商品コード（sku）が無い明細は商品名だけにする（存在しない番号を作らない）。
  //   バリアント名が Default Title / 空のものは省く（倉庫の紙に無意味な語を出さない）。
  function formatNoteLineItem(item) {
    var it = item || {};
    var name = String(it.product_title == null ? '' : it.product_title).trim();
    var vt = String(it.variant_title == null ? '' : it.variant_title).trim();
    if (vt && vt !== 'Default Title') name = name + ' - ' + vt;
    var sku = String(it.sku == null ? '' : it.sku).trim();
    return sku ? sku + '　' + name : name;
  }

  // カート明細から作業指示ブロックを組み立てる（純関数）。
  //   _wrap_id で対象明細と資材明細を突き合わせ、**両方揃ったペアだけ**を出す。
  //   片側だけ（孤児）は出さない —— 孤児は整合チェッカーの担当で、
  //   曖昧なまま倉庫の紙に載せると誤作業になる。
  //   ペアが1つも無ければ空文字を返す（＝note からブロックを消す指示になる）。
  function buildWarehouseNoteBlock(items) {
    var byToken = {};
    var order = [];
    (items || []).forEach(function (it) {
      var props = (it && it.properties) || {};
      var token = props[KEY_WRAP_ID];
      if (!token) return;
      if (!byToken[token]) {
        byToken[token] = { target: null, material: null };
        order.push(token);
      }
      // 対象側は PROP_TARGET を、資材側は PROP_MATERIAL を持つ（buildPairItems と対応）。
      if (props[PROP_TARGET]) byToken[token].target = it;
      else if (props[PROP_MATERIAL]) byToken[token].material = it;
    });

    var lines = [];
    order.forEach(function (token) {
      var pair = byToken[token];
      if (!pair.target || !pair.material) return; // 孤児は載せない
      lines.push(
        '・' +
          formatNoteLineItem(pair.target) +
          '\n　を ' +
          formatNoteLineItem(pair.material) +
          ' で風呂敷包みにてご対応をお願いいたします。'
      );
    });

    if (!lines.length) return '';
    return NOTE_MARK_BEGIN + '\n' + lines.join('\n') + '\n' + NOTE_MARK_END;
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // 既存 note の管理区間だけを差し替える（純関数・冪等）。
  //   顧客が書いた文は残し、ブロックは先頭に置く（案B）。
  //   ブロックが空なら管理区間を消して顧客の文だけにする。
  //   同じカートに対して何度呼んでも結果が変わらないこと（冪等）をテストで担保する。
  function mergeWarehouseNote(existingNote, block) {
    var note = String(existingNote == null ? '' : existingNote);
    var re = new RegExp(escapeRegExp(NOTE_MARK_BEGIN) + '[\\s\\S]*?' + escapeRegExp(NOTE_MARK_END), 'g');
    var customer = note.replace(re, '').replace(/^\s+|\s+$/g, '');
    var b = String(block == null ? '' : block).trim();
    if (!b) return customer;
    return customer ? b + '\n\n' + customer : b;
  }

  var api = {
    KEY_WRAP_ID: KEY_WRAP_ID,
    PROP_TARGET: PROP_TARGET,
    PROP_MATERIAL: PROP_MATERIAL,
    NOTE_MARK_BEGIN: NOTE_MARK_BEGIN,
    NOTE_MARK_END: NOTE_MARK_END,
    formatNoteLineItem: formatNoteLineItem,
    buildWarehouseNoteBlock: buildWarehouseNoteBlock,
    mergeWarehouseNote: mergeWarehouseNote,
    escapeHtml: escapeHtml,
    newToken: newToken,
    buildPairItems: buildPairItems,
    buildBagItem: buildBagItem,
    filterShelf: filterShelf,
    detectSize: detectSize,
    isFuroshikiTitle: isFuroshikiTitle,
    isBagTitle: isBagTitle,
    classifyGroup: classifyGroup,
    materialSize: materialSize,
    shouldShowCartModule: shouldShowCartModule,
    analyzeCart: analyzeCart,
    buildAutoOps: buildAutoOps,
    planChecker: planChecker,
    stripWrapProps: stripWrapProps,
  };

  // ========================= ブラウザ配線 =========================

  var busy = false;
  function setBusy(v) {
    busy = !!v;
  }
  function isBusy() {
    return busy;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(
          function (d) {
            throw new Error((d && (d.description || d.message)) || 'cart error');
          },
          function () {
            throw new Error('cart error');
          }
        );
      }
      return res.json();
    });
  }
  function postAdd(items) {
    return postJSON('/cart/add.js', { items: items });
  }
  function postChange(body) {
    return postJSON('/cart/change.js', body);
  }
  function postUpdate(body) {
    return postJSON('/cart/update.js', body);
  }
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  // カートの現状から note の管理区間を作り直す（2026-08-18）。
  //   カートを読んで組み立て直すので冪等。追加・削除・自動修復のあと必ず通す。
  //   note が変わらないときは書き込みを飛ばす（無駄な /cart/update.js を打たない）。
  //   preloaded を渡すと再取得しない（runChecker は直前に読んだカートをそのまま使う）。
  function syncWarehouseNote(preloaded) {
    return (preloaded ? Promise.resolve(preloaded) : fetchCart()).then(function (cart) {
      var block = buildWarehouseNoteBlock((cart && cart.items) || []);
      var next = mergeWarehouseNote(cart && cart.note, block);
      if (String(cart && cart.note ? cart.note : '') === next) return cart;
      return postUpdate({ note: next });
    });
  }

  // note 同期 → 表示更新。同期に失敗しても表示更新は続ける（カートが固まるのを避ける）。
  //   ただし黙って飲まない: 失敗はコンソールに出す（倉庫に指示が届かない事故なので）。
  function syncThenRefresh() {
    return syncWarehouseNote()
      .catch(function (e) {
        try {
          console.warn('[senchado-gift-wrap] 出荷指示の note 同期に失敗:', e && e.message ? e.message : e);
        } catch (_) {}
      })
      .then(refreshCart);
  }

  // 対象明細の gift_wrap_size マップ（variant_id → 'small'|'large'）を読む。
  // cart snippet がサーバ側 metafield から出力（[data-sc-gw-target-sizes]）。無ければ空＝サイズ照合スキップ。
  // ⚠️ 層2の守備範囲＝「未包装対象があるカート」のみ。data-sc-gw-target-sizes マップは cart snippet が
  //   gw_target_count > 0（未包装対象が存在）の時だけ描画されるため、全対象が既に包装済みのカートへ
  //   直POSTでサイズ不一致ペアを注入する経路は層2では検知できない（wrapSize が引けず照合スキップ）。
  //   最終防波堤は層3サーバ検証（spec §G3b）。本層はUX担保に留める（コードは変えない・限界の明示）。
  function readTargetSizeMap() {
    try {
      var el = document.querySelector('[data-sc-gw-target-sizes]');
      if (!el) return {};
      var map = JSON.parse(el.textContent || '{}');
      return map && typeof map === 'object' ? map : {};
    } catch (_) {
      return {};
    }
  }

  function onCartPage() {
    return !!document.getElementById('main-cart-items');
  }

  function findByKey(items, key) {
    if (!key) return null;
    for (var i = 0; i < (items || []).length; i++) {
      if (items[i] && items[i].key === key) return items[i];
    }
    return null;
  }

  // ---- 層2: 未解決の materialOrphan がある間はチェックアウトを止める ----
  // 「中身のない包装箱」だけが注文に残る曖昧注文を、レジ導線を無効化して防ぐ（層3が最終防波堤）。
  function checkoutControls() {
    return document.querySelectorAll(
      '[name="checkout"], #checkout, #CartDrawer-Checkout, .cart__checkout-button, .cart__dynamic-checkout-buttons, .shopify-payment-button'
    );
  }
  function setCheckoutBlocked(blocked) {
    var nodes = checkoutControls();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (blocked) {
        el.setAttribute('data-sc-gw-blocked', '1');
        el.setAttribute('aria-disabled', 'true');
        if ('disabled' in el) el.disabled = true;
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.5';
      } else if (el.getAttribute('data-sc-gw-blocked')) {
        // このモジュールが止めたものだけ解除（cart==empty 等の本来の disabled は触らない）
        el.removeAttribute('data-sc-gw-blocked');
        el.removeAttribute('aria-disabled');
        if ('disabled' in el) el.disabled = false;
        el.style.pointerEvents = '';
        el.style.opacity = '';
      }
    }
  }

  // 変更後の表示反映: カートページはリロード / ドロワーは section 再描画。
  function refreshCart() {
    if (onCartPage()) {
      window.location.reload();
      return Promise.resolve();
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      return fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (sections) {
          try {
            drawer.renderContents({ sections: sections });
          } catch (_) {}
        })
        .catch(function () {});
    }
    return Promise.resolve();
  }

  function renderDrawerFromAdd(data) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    try {
      var sec = data && data.sections;
      if (sec && sec['cart-drawer'] && sec['cart-icon-bubble'] && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
      } else if (typeof drawer.open === 'function') {
        drawer.open();
      }
    } catch (_) {}
  }

  // ---- PDP: 「ギフト包装」オプション → 2明細一括追加 ----
  function initPdp() {
    var box = document.querySelector('[data-sc-giftwrap-pdp]');
    if (!box) return;

    // カード選択の見た目同期。
    //   🔴 見た目は必ず「ラジオの checked」から導出する（2026-08-21 修正）。
    //   旧実装は change を受けた input のカードへ **無条件に** is-selected を付け直していた。
    //   外す処理（下）は is-selected を消したあとに change を自分で投げるため、
    //   その change が見た目だけ復活させ「ラジオは外れているのにチェックマークが残る」状態になっていた
    //   （谷本さん実機指摘: クリック2回してもオンオフしないのに Shop Pay だけ消える）。
    //   単一の導出関数にしておけば、この取り違えは構造的に起きない。
    function syncSelected() {
      box.querySelectorAll('.sc-gw-card').forEach(function (c) {
        var i = c.querySelector('input[name="sc-gw-choice"]');
        c.classList.toggle('is-selected', !!(i && i.checked));
      });
    }
    box.querySelectorAll('input[name="sc-gw-choice"]').forEach(function (inp) {
      inp.addEventListener('change', syncSelected);
    });

    // 選んだ色をもう一度押したら外す（＝包まない）。2026-08-12 の決裁で「包装しない」カードを
    //   廃止したため、未選択に戻す手段がこれしかない。ラジオは既定では外せないので明示的に外す。
    //   mousedown で「押す前の状態」を控え、click で判定する（click 時点では既に checked=true）。
    box.addEventListener('mousedown', function (e) {
      var lab = e.target.closest ? e.target.closest('.sc-gw-card') : null;
      if (!lab) return;
      var inp = lab.querySelector('input[name="sc-gw-choice"]');
      lab.setAttribute('data-was-checked', inp && inp.checked ? '1' : '0');
    });
    box.addEventListener('click', function (e) {
      var lab = e.target.closest ? e.target.closest('.sc-gw-card') : null;
      if (!lab) return;
      if (lab.getAttribute('data-was-checked') !== '1') return;
      var inp = lab.querySelector('input[name="sc-gw-choice"]');
      if (!inp) return;
      e.preventDefault();
      inp.checked = false;
      lab.setAttribute('data-was-checked', '0');
      syncSelected();
      // 加速決済の出し分け（product-hero.js）へ通知する。change は checked=false では発火しない。
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
    // キーボード操作（Space/Enter）でも外せるようにする。
    box.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Enter') return;
      var lab = e.target.closest ? e.target.closest('.sc-gw-card') : null;
      if (!lab) return;
      var inp = lab.querySelector('input[name="sc-gw-choice"]');
      if (!inp || !inp.checked) return;
      e.preventDefault();
      inp.checked = false;
      syncSelected();
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // .btn-cart の click を capture フェーズで先取り。包装が選ばれている時だけ乗っ取る。
    // （product-hero.js の bubble リスナより前に発火し、stopImmediatePropagation で通常追加を抑止）
    document.addEventListener(
      'click',
      function (e) {
        // 監査 M9: 対象を実カートボタン（<button class="btn-cart">）に限定する。
        // 先行発売ロック時の「ログインして確認」は <a class="btn-cart early-access-login-button">
        // というアンカーで、旧セレクタ '.btn-cart' だとこれを乗っ取り preventDefault で
        // ログイン遷移まで殺していた。button 限定＋ロックボタン除外で完全に手を出さない。
        var btn = e.target.closest('button.btn-cart');
        if (!btn || btn.disabled) return;
        if (btn.classList.contains('early-access-button-locked')) return;
        // 売切れの種類を選んでいるなら包装つきでも送らない（PDPで売切れの種類も選べるようにしたため）。
        var heroSel = document.getElementById('variantSelect');
        var heroData = window.SENCHADO_HERO_DATA;
        if (heroSel && heroData && heroData.stock_data && heroData.stock_data[heroSel.value] === 'out') return;
        var checked = box.querySelector('input[name="sc-gw-choice"]:checked');
        // 「包装しない」カードは廃止したので、未選択＝checked が null。値の比較は不要。
        var wrapSelected = !!checked;
        // お渡し用紙袋（風呂敷と独立・チェックボックス）。チェック時は数量1の通常明細を1行足す。
        //   2026-08-21: 紙袋は (大)/(細長) の2商品を並べるようになったので、チェックされた分だけ足す
        //   （querySelector だと最初の1枚しか見ず、2つ目を選んでも黙って落ちる）。
        var bagCbs = Array.prototype.filter.call(
          box.querySelectorAll('[data-sc-gw-bag-toggle]'),
          function (cb) {
            return cb.checked && !cb.disabled;
          }
        );
        var bagOn = bagCbs.length > 0;
        if (!wrapSelected && !bagOn) return; // 包装も紙袋も無し → 通常追加に委ねる
        e.preventDefault();
        e.stopImmediatePropagation();

        // 対象商品（このPDPの選択中バリアント）を解決。個数は product-hero の通常追加と同じく常に1。
        var sel = document.getElementById('variantSelect');
        var targetVariantId = null;
        if (sel && sel.options[sel.selectedIndex]) {
          targetVariantId = Number(sel.options[sel.selectedIndex].getAttribute('data-variant-id'));
        }
        if (!targetVariantId) targetVariantId = Number(box.getAttribute('data-default-variant-id'));
        var targetTitle = box.getAttribute('data-product-title');

        var items = [];
        var productIncluded = false; // 対象商品が items に含まれたか（ペア or 単独明細）
        if (wrapSelected) {
          // 包装ペア: 対象明細（＝この商品・qty1）＋資材明細を _wrap_id で紐付け。対象はペアに含まれる。
          var card = checked.closest('.sc-gw-card');
          var materialVariantId = Number(checked.value);
          // 明細に載せる文言は data-wrap-label（例「紺の風呂敷（48cm）で包む」）。
          //   倉庫は対象商品の行だけ読めば、色もサイズも分かる状態にする。
          //   古い描画（属性なし）に当たったら色名だけにフォールバックする。
          var materialName = card
            ? card.getAttribute('data-wrap-label') || card.getAttribute('data-name') || ''
            : '';
          if (targetVariantId && materialVariantId) {
            var token = newToken();
            items = items.concat(
              buildPairItems({
                targetVariantId: targetVariantId,
                materialVariantId: materialVariantId,
                materialName: materialName,
                targetTitle: targetTitle,
                token: token,
              })
            );
            productIncluded = true;
          }
        }
        if (bagOn) {
          // 包装なしで紙袋だけの時は通常追加を乗っ取ったぶん対象商品も明示追加（qty1・product-hero と同一）。
          //   包装ありなら対象はペアに含まれるので二重追加しない（productIncluded で判定）。
          if (!productIncluded && targetVariantId) {
            items.push({ id: targetVariantId, quantity: 1 });
            productIncluded = true;
          }
          bagCbs.forEach(function (cb) {
            var bagVariantId = Number(cb.getAttribute('data-variant-id'));
            if (bagVariantId) items.push(buildBagItem(bagVariantId));
          });
        }
        if (!items.length) return; // 何も組み立てられなければ通常追加を邪魔しない

        var original = btn.textContent;
        btn.disabled = true;
        btn.dataset.busy = '1';
        btn.textContent = '追加中...';
        var drawer = document.querySelector('cart-drawer');
        var body = { items: items };
        if (drawer) {
          body.sections = 'cart-drawer,cart-icon-bubble';
          body.sections_url = window.location.pathname;
        }
        postAdd(body.items)
          .then(function () {
            // sections 付きで取り直してドロワー再描画（add.js の items 単独では sections が返らないため）
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            btn.textContent = 'カートに追加しました';
            return syncThenRefresh();
          })
          .then(function () {
            var dr = document.querySelector('cart-drawer');
            if (dr && typeof dr.open === 'function') dr.open();
            setTimeout(function () {
              restoreBtn(btn, original);
            }, 1800);
          })
          .catch(function (err) {
            var errEl = document.querySelector('[data-cart-error]');
            if (errEl) {
              errEl.textContent = err.message;
              errEl.hidden = false;
            }
            restoreBtn(btn, original);
          });
      },
      true
    );
  }

  // ---- カート内「ギフト包装を追加」モジュールは 2026-08-12 に廃止 ----
  //   包装を選ぶ場所は商品ページ1箇所にした（谷本決裁）。ここにあった
  //   資材カードの「＋追加」→対象を数量-1して2明細追加する処理・対象選択のサイズ絞り込み・
  //   カート用エラー表示は、すべて不要になったので削除した。
  //   カートに残すのは「選んだ内容の表示」「数量ロック」「下の整合チェッカー」の3つだけ。

  // ---- 層2: 整合チェッカー ----
  function cartSurface() {
    // 確認UIを差し込める可視カート面（カートページ or ドロワー）。
    return (
      // 2026-08-12: カート内モジュールを廃止したので、専用の差し込み口を最優先で使う。
      //   .drawer__inner は差し込むとフッターを押し出す既知の場所なので最後に置く。
      document.querySelector('[data-sc-gw-notice-slot]') ||
      document.getElementById('main-cart-items') ||
      document.querySelector('cart-drawer .drawer__inner') ||
      null
    );
  }

  function showOrphanConfirm(materialOrphans) {
    var surface = cartSurface();
    if (!surface) return; // 差し込み先が無ければ次回カート表示時に扱う
    materialOrphans.forEach(function (m) {
      // 二重表示防止・削除対象の特定は **race-safe な line item key** で行う（位置indexは使わない）。
      var mKey = m.key;
      if (!mKey) return; // key 不明なら破壊的削除を発行しない（層3に委ねる）
      var sel = '[data-sc-gw-alert-key="' + (window.CSS && CSS.escape ? CSS.escape(mKey) : mKey) + '"]';
      if (document.querySelector(sel)) return;
      var materialName = m.product_title || m.title || '包装資材';
      var removedTarget = (m.properties && m.properties[PROP_MATERIAL]) || '対象商品';
      var el = document.createElement('div');
      el.className = 'sc-gw-alert';
      el.setAttribute('data-sc-gw-alert-key', mKey);
      el.innerHTML =
        '<p class="sc-gw-alert__msg">包装対象「' +
        escapeHtml(removedTarget) +
        '」がカートから外れました。ギフト包装「' +
        escapeHtml(materialName) +
        '」をどうしますか？（解決するまでレジに進めません）</p>' +
        '<div class="sc-gw-alert__actions">' +
        '<button type="button" class="sc-gw-alert__btn sc-gw-alert__btn--primary" data-gw-orphan="remove">包装を外す</button>' +
        '<button type="button" class="sc-gw-alert__btn" data-gw-orphan="keep">単体で購入する</button>' +
        '</div>';
      el.querySelector('[data-gw-orphan="remove"]').addEventListener('click', function () {
        orphanAction(mKey, 'remove', null, el);
      });
      el.querySelector('[data-gw-orphan="keep"]').addEventListener('click', function () {
        orphanAction(mKey, 'keep', m.properties || {}, el);
      });
      surface.insertBefore ? surface.insertBefore(el, surface.firstChild) : surface.appendChild(el);
    });
  }

  function orphanAction(key, action, props, el) {
    if (isBusy()) return; // 並行押下ガード（複数アラートの同時解決で位置ズレ削除を防ぐ）
    if (!key) return; // key 無しでは破壊的削除を発行しない
    var btns = el ? el.querySelectorAll('button') : [];
    btns.forEach(function (b) {
      b.disabled = true;
    });
    setBusy(true);
    var op;
    if (action === 'remove') {
      op = postChange({ id: key, quantity: 0 }); // 資材明細を削除（key指定＝reindexレース安全）
    } else {
      op = postChange({ id: key, properties: stripWrapProps(props || {}) }); // 単体購入＝紐付け除去
    }
    op.then(function () {
      setBusy(false);
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      return syncThenRefresh();
    }).catch(function () {
      setBusy(false);
      btns.forEach(function (b) {
        b.disabled = false;
      });
    });
  }

  function runChecker() {
    if (isBusy()) return;
    var sizeMap = readTargetSizeMap();
    fetchCart()
      .then(function (cart) {
        var items = (cart.items || []).map(function (it, i) {
          return {
            line: i + 1,
            key: it.key, // race-safe な line item key（自動修復・削除はこれで送る）
            id: it.id,
            quantity: it.quantity,
            properties: it.properties || {},
            product_title: it.product_title,
            title: it.title,
            // サイズ照合用（2026-07-21）: 風呂敷の資材明細だけ variant title からサイズ判定。
            //   materialSize がサーバ規則（product_title contains '風呂敷'）でゲートし、箱等は null にする。
            //   無条件 detectSize だと箱の variant 名（「大」等）で誤って size が付き、正当ペアが
            //   サイズ不一致分岐で破壊される（敵対レビュー指摘1・クライアント/サーバの非対称解消）。
            size: materialSize(it),
            // 対象明細は gift_wrap_size をサーバ出力マップ（variant_id 起点）から引く。
            wrapSize: sizeMap[it.id] || sizeMap[String(it.id)] || null,
          };
        });
        // 自動修復オペは **key で送る**（qtyのproperty変更由来 line-merge や他タブ操作の reindex に安全）。
        var plan = planChecker(analyzeCart(items));
        if (plan.autoOps.length) {
          setBusy(true);
          var chain = Promise.resolve();
          plan.autoOps.forEach(function (op) {
            chain = chain.then(function () {
              return postChange(op);
            });
          });
          chain
            .then(function () {
              setBusy(false);
              return syncThenRefresh();
            })
            .then(function () {
              // 監査 M27: 修復後は materialOrphan 判定を必ず通す。ドロワー経路は refreshCart が
              //   renderContents で DOM を差し替えるだけで cart:updated も撒かず runChecker も再起動しないため、
              //   autoOps（数量矯正・対象孤児）と materialOrphan（対象削除・資材残存）が同一パスで共存すると、
              //   「中身のない包装だけの注文」のレジ停止・確認UIが未適用のまま残りチェックアウト可能になる。
              //   カートページは refreshCart=full reload で runChecker が新規実行され自己回復するため、そこでは再走査しない。
              if (!onCartPage()) runChecker();
            })
            .catch(function () {
              setBusy(false);
            });
          return;
        }
        if (plan.blockCheckout) {
          setCheckoutBlocked(true); // 未解決の「中身のない包装」がある間はレジを止める
          showOrphanConfirm(plan.materialOrphans);
        } else {
          setCheckoutBlocked(false);
        }
        // 自動修復が走らない経路でも note を作り直す（2026-08-21）。ここを通さないと
        //   「対象と資材の両方をカートUIで消した」終端状態で古い指示が備考欄に残り続ける。
        //   syncThenRefresh ではなく syncWarehouseNote を呼ぶ: refreshCart はカートページで
        //   全リロードするため、runChecker の再入で無限リロードになる。
        //   直前に読んだ cart を渡して /cart.js の再取得を避ける（429 を踏みに行かない）。
        if (!plan.syncNote) return;
        return syncWarehouseNote(cart).catch(function (e) {
          try {
            console.warn('[senchado-gift-wrap] 出荷指示の note 同期に失敗:', e && e.message ? e.message : e);
          } catch (_) {}
        });
      })
      .catch(function () {});
  }

  function initBrowser() {
    // 二重ロード防止（PDP option + cart/drawer の複数 <script> でも1回だけ配線）
    if (typeof window !== 'undefined') {
      if (window.__scGiftWrapInit) return;
      window.__scGiftWrapInit = true;
    }
    var start = function () {
      initPdp();
      runChecker();
      document.addEventListener('cart:updated', runChecker);
      // Dawn の PubSub があれば数量変更(cartUpdate)も購読して qty>1 矯正等を拾う
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          subscribe(PUB_SUB_EVENTS.cartUpdate, runChecker);
        }
      } catch (_) {}
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }

  api._initBrowser = initBrowser;
  return api;
});
